<script setup lang="ts">
  import { onMounted, watch } from 'vue'
  import { mountFloatingVueInstances, unmountFloatingVueInstances } from '@/legacy/vue-manager.ts'
  import { useRoute, type RouteParamValue } from 'vue-router'
  import { axiosClient } from '@/utils/axios-client'

  const route = useRoute()

  const props = defineProps<{ url: string; scripts: string[] }>()

  let lastFetch = ''

  async function fetchPage() {
    const urlParams: Record<string, RouteParamValue | RouteParamValue[] | undefined> = {
      ...route.params,
    }

    let url = props.url

    if (urlParams['uuid'] != null) {
      url += `/${urlParams['uuid']}`
    }

    if (urlParams['paramsonlyuuid'] != null) {
      urlParams['uuid'] = urlParams['paramsonlyuuid']
      urlParams['paramsonlyuuid'] = undefined
    }

    if (urlParams['type'] != null) {
      url += `/${urlParams['type']}`
    }
    if (route.name && typeof route.name == 'string') {
      url += (url.includes('?') ? '&' : '?') + 'submodule=' + route.name
      window.currentSubmodule = route.name
    }
    // TODO fix this
    if (lastFetch == url) {
      return
    }
    lastFetch = url
    const result = await axiosClient.request<string>({ url: url, params: urlParams })

    if (result === undefined) return

    unmountFloatingVueInstances()
    $('#content').html(result.data)
    mountFloatingVueInstances()
    $('#content .header-title').remove()
    $('#content .header').remove()

    if (props.scripts) {
      for (const script of props.scripts) {
        window.dispatchEvent(
          new CustomEvent('legacy-content:initialize-script', { detail: { script } })
        )
      }
    }
  }

  watch(() => route.path, fetchPage, { immediate: true })
  onMounted(fetchPage)
</script>

<template>
  <div
    id="content"
    class="d-flex flex-column"
    style="
      padding: 32px 16px 16px 16px;
      flex: 1 1 auto;
      min-height: 100px;
      overflow: auto;
      position: relative;
    "
  ></div>
</template>

<style scoped></style>
